module.exports = __webpack_public_path__ + "img/status-support.3e2d2c35.png";